import React, { useEffect, useState } from "react";
import styles from "./reviewTile.module.scss";
import reviewImg1 from "../../../assets/images/reviewProductImg1.jpg";
import reviewImg2 from "../../../assets/images/reviewProductImg2.jpg";
import { StarBorderRounded } from "@mui/icons-material";
import {
  getFormatedDateWithMonthText,
  getObjectFromArrayOfObjects,
} from "../../../utils/common/CommonFunctions";
import { connect, useDispatch } from "react-redux";
import { getAllCustomer } from "../../../store/actions";

const ReviewTile = ({ reviews, customers = [] }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllCustomer());
  }, []);

  const getDate = (data) => {
    const getDateAndMonth = getFormatedDateWithMonthText(data);
    return getDateAndMonth;
  };
  const getNameByCustomerId = (customerid) => {
    const getname =
      getObjectFromArrayOfObjects(customers, "id", customerid)?.firstName ||
      "NA";
    return getname;
  };
  return (
    <div className={styles.container}>
      <div className={styles.images}>
        {/* <div className={styles.imgContainer}>
          <img src={reviewImg1} alt="review1" />
        </div>
        <div className={styles.imgContainer}>
          <img src={reviewImg2} alt="review2" />
        </div> */}
      </div>

      <div className={styles.stars}>
        {[...Array(5)].map((_, index) => (
          <span
            key={index}
            style={{
              fontSize: "24px",
              color: index < reviews[0]?.rating || 0 ? "gold" : "gold",
            }}
          >
            {index < reviews[0]?.rating || 0 ? "★" : "☆"}
          </span>
        ))}
        {/* {[...Array(5-reviews?.review)].map((_, index) => (
          <div key={index} className={styles.star}>
            <StarBorderRounded />
          </div>
        ))} */}
      </div>
      <div>
        {reviews?.map((item, idx) => {
          return (
            <div>
              <div className={styles.reviewerName}>
                {getNameByCustomerId(item?.customerId)}
              </div>
              {/* <div className={styles.reviewText}>
                {item?.description}
              </div> */}
              <div className={styles.footer}>
                <div className={styles.date}>
                  Posted on {getDate(item?.createdAt)}{" "}
                </div>
                {/* <div className={styles.reply} >Reply</div> */}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
const mapStateToProps = (state, props) => {
  return {
    customers: state?.customer?.customers,
  };
};
export default connect(mapStateToProps, null)(ReviewTile);
